import LegalPage from "@/components/LegalPage";
import { LEGAL_LAST_UPDATED } from "@/data/legal";

const sections = [
  {
    h: "1. Acceptance of Terms",
    blocks: [
      { type: "p", text: "Welcome to the School Smile Australia website (\u201CWebsite\u201D)." },
      { type: "p", text: "These Terms and Conditions govern your access to and use of this Website operated by School Smile Australia Pty Ltd (\u201CSchool Smile Australia\u201D, \u201Cwe\u201D, \u201Cour\u201D, or \u201Cus\u201D)." },
      { type: "p", text: "By accessing or using this Website, you acknowledge that you have read, understood and agree to be bound by these Terms and Conditions." },
      { type: "p", text: "If you do not agree with these Terms and Conditions, you must discontinue use of this Website." },
    ],
  },
  {
    h: "2. Purpose of this Website",
    blocks: [
      { type: "p", text: "This Website provides general information regarding:" },
      { type: "ul", items: [
        "School Smile Australia",
        "Mobile dental services",
        "School dental programmes",
        "Oral health education",
        "Preventive dental care",
        "Parent information",
        "School information",
        "Appointment enquiries",
        "Educational resources",
      ]},
      { type: "p", text: "The information contained on this Website is intended for general informational purposes only." },
    ],
  },
  {
    h: "3. No Dental or Medical Advice",
    blocks: [
      { type: "p", text: "The information contained on this Website is general in nature and is provided for educational purposes only." },
      { type: "p", text: "Nothing on this Website constitutes:" },
      { type: "ul", items: [
        "Dental advice",
        "Medical advice",
        "Diagnosis",
        "Treatment recommendations",
        "Professional healthcare advice",
      ]},
      { type: "p", text: "Information on this Website should never replace an examination or consultation with a registered dental practitioner or other qualified healthcare professional." },
    ],
  },
  {
    h: "4. No Dentist\u2013Patient Relationship",
    blocks: [
      { type: "p", text: "Accessing this Website, contacting School Smile Australia, submitting online enquiries or completing electronic forms does not create a dentist\u2013patient relationship." },
      { type: "p", text: "A dentist\u2013patient relationship is established only when:" },
      { type: "ul", items: [
        "Appropriate consent has been obtained;",
        "School Smile Australia has agreed to provide dental services; and",
        "A clinical assessment has been undertaken where appropriate.",
      ]},
    ],
  },
  {
    h: "5. Eligibility to Use the Website",
    blocks: [
      { type: "p", text: "You agree to use this Website only for lawful purposes." },
      { type: "p", text: "You must not:" },
      { type: "ul", items: [
        "Breach any Australian law;",
        "Interfere with Website security;",
        "Attempt unauthorised access to our systems;",
        "Introduce malware, viruses or malicious code;",
        "Interfere with Website functionality; or",
        "Use automated software to scrape Website content without written permission.",
      ]},
    ],
  },
  {
    h: "6. Online Forms",
    blocks: [
      { type: "p", text: "School Smile Australia may provide online forms including:" },
      { type: "ul", items: [
        "Parent Consent Forms",
        "School Enquiry Forms",
        "Appointment Requests",
        "Contact Forms",
      ]},
      { type: "p", text: "Submitting a form does not guarantee:" },
      { type: "ul", items: [
        "Acceptance as a patient;",
        "Appointment availability;",
        "Provision of services; or",
        "Eligibility for Medicare or the Child Dental Benefits Schedule (CDBS).",
      ]},
      { type: "p", text: "School Smile Australia reserves the right to accept or decline any request where appropriate and permitted by law." },
    ],
  },
  {
    h: "7. Medicare and Child Dental Benefits Schedule (CDBS)",
    blocks: [
      { type: "p", text: "Information regarding Medicare and the Child Dental Benefits Schedule (CDBS) is provided for general guidance only." },
      { type: "p", text: "Eligibility for government-funded dental services is determined by Services Australia and applicable legislation." },
      { type: "p", text: "School Smile Australia cannot guarantee:" },
      { type: "ul", items: [
        "Eligibility;",
        "Available benefits;",
        "Future funding; or",
        "Approval of Medicare claims.",
      ]},
      { type: "p", text: "Parents or guardians should confirm eligibility with Services Australia." },
    ],
  },
  {
    h: "8. Privacy",
    blocks: [
      { type: "p", text: "School Smile Australia collects, stores, uses and discloses personal information in accordance with:" },
      { type: "ul", items: [
        "Privacy Act 1988 (Cth)",
        "Australian Privacy Principles (APPs)",
        "Health Records Act 2001 (Vic) (where applicable)",
        "Other applicable Australian privacy legislation",
      ]},
      { type: "p", text: "Please read our Privacy Policy before submitting personal information through this Website." },
    ],
  },
  {
    h: "9. Cookies",
    blocks: [
      { type: "p", text: "This Website uses cookies and similar technologies to improve user experience, security and Website performance." },
      { type: "p", text: "Further information is available in our Cookies Policy." },
    ],
  },
  {
    h: "10. Intellectual Property",
    blocks: [
      { type: "p", text: "Unless otherwise stated, all Website content including:" },
      { type: "ul", items: [
        "Logos",
        "Branding",
        "Graphics",
        "Icons",
        "Photographs",
        "Videos",
        "Educational resources",
        "Downloadable documents",
        "Website design",
        "Software",
        "Written content",
      ]},
      { type: "p", text: "is owned by or licensed to School Smile Australia and is protected under the Copyright Act 1968 (Cth) and other applicable intellectual property laws." },
      { type: "p", text: "You may download or print Website material for your personal, non-commercial use only." },
      { type: "p", text: "You must not reproduce, distribute, modify, publish, transmit or commercially exploit Website content without prior written permission from School Smile Australia." },
    ],
  },
  {
    h: "11. Accuracy of Information",
    blocks: [
      { type: "p", text: "School Smile Australia makes reasonable efforts to ensure that information published on this Website is accurate and current." },
      { type: "p", text: "However, we do not warrant that Website information is:" },
      { type: "ul", items: [
        "Complete;",
        "Accurate;",
        "Current;",
        "Error-free; or",
        "Suitable for every individual circumstance.",
      ]},
      { type: "p", text: "Information may be updated or removed without notice." },
    ],
  },
  {
    h: "12. Third-Party Websites",
    blocks: [
      { type: "p", text: "This Website may contain links to third-party websites." },
      { type: "p", text: "These links are provided for convenience only." },
      { type: "p", text: "School Smile Australia:" },
      { type: "ul", items: [
        "Does not control third-party websites;",
        "Does not endorse their content unless expressly stated; and",
        "Accepts no responsibility for the availability, accuracy or privacy practices of third-party websites.",
      ]},
      { type: "p", text: "Accessing third-party websites is entirely at your own risk." },
    ],
  },
  {
    h: "13. Website Availability",
    blocks: [
      { type: "p", text: "We aim to keep this Website available at all times." },
      { type: "p", text: "However, we do not guarantee uninterrupted access." },
      { type: "p", text: "The Website may occasionally become unavailable because of:" },
      { type: "ul", items: [
        "Scheduled maintenance;",
        "Software updates;",
        "Internet outages;",
        "Technical failures;",
        "Cyber security incidents; or",
        "Events beyond our reasonable control.",
      ]},
    ],
  },
  {
    h: "14. Limitation of Liability",
    blocks: [
      { type: "p", text: "To the maximum extent permitted by law, School Smile Australia excludes all liability for any loss, damage, cost or expense (including indirect, incidental or consequential loss) arising from:" },
      { type: "ul", items: [
        "Use of this Website;",
        "Reliance upon Website information;",
        "Inability to access the Website;",
        "Technical errors;",
        "Malware or viruses;",
        "Third-party websites; or",
        "Delays in responding to enquiries.",
      ]},
      { type: "p", text: "Nothing in these Terms excludes rights that cannot legally be excluded under the Competition and Consumer Act 2010 (Cth), including the Australian Consumer Law." },
    ],
  },
  {
    h: "15. User Information",
    blocks: [
      { type: "p", text: "By submitting information through this Website, you warrant that:" },
      { type: "ul", items: [
        "The information provided is true and accurate;",
        "You have authority to provide the information;",
        "The information does not infringe another person\u2019s rights; and",
        "The information is not unlawful, misleading or deceptive.",
      ]},
      { type: "p", text: "School Smile Australia reserves the right to remove information that is unlawful or inappropriate." },
    ],
  },
  {
    h: "16. Website Security",
    blocks: [
      { type: "p", text: "Users are responsible for ensuring their own devices are protected against viruses and other cyber threats." },
      { type: "p", text: "Although School Smile Australia uses reasonable security measures, no Website or internet transmission can be guaranteed to be completely secure." },
    ],
  },
  {
    h: "17. Children\u2019s Information",
    blocks: [
      { type: "p", text: "School Smile Australia primarily provides dental services to school-aged children." },
      { type: "p", text: "Parents or legal guardians are responsible for:" },
      { type: "ul", items: [
        "Providing accurate medical information;",
        "Providing informed consent; and",
        "Notifying School Smile Australia of any changes relevant to their child\u2019s dental care.",
      ]},
      { type: "p", text: "The collection and management of children\u2019s personal information is governed by our Privacy Policy." },
    ],
  },
  {
    h: "18. Changes to the Website",
    blocks: [
      { type: "p", text: "School Smile Australia may update, modify, suspend or remove any part of this Website at any time without prior notice." },
    ],
  },
  {
    h: "19. Changes to these Terms and Conditions",
    blocks: [
      { type: "p", text: "These Terms and Conditions may be updated periodically." },
      { type: "p", text: "The latest version will always be published on this Website." },
      { type: "p", text: "Continued use of the Website after changes have been published constitutes acceptance of the revised Terms and Conditions." },
    ],
  },
  {
    h: "20. Governing Law",
    blocks: [
      { type: "p", text: "These Terms and Conditions are governed by the laws of the Commonwealth of Australia and, where applicable, the laws of the State of Victoria." },
      { type: "p", text: "Any disputes relating to these Terms and Conditions shall be subject to the exclusive jurisdiction of the courts of Australia." },
    ],
  },
  {
    h: "21. Severability",
    blocks: [
      { type: "p", text: "If any provision of these Terms and Conditions is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect." },
    ],
  },
  {
    h: "22. Entire Agreement",
    blocks: [
      { type: "p", text: "These Terms and Conditions, together with the School Smile Australia Privacy Policy, Cookies Policy and Website Disclaimer, constitute the entire agreement between you and School Smile Australia regarding your use of this Website." },
    ],
  },
  {
    h: "23. Contact Us",
    blocks: [
      { type: "p", text: "If you have any questions regarding these Terms and Conditions, please contact us:" },
      { type: "p", text: "School Smile Australia" },
      { type: "link", label: "Email: ", href: "mailto:info@schoolsmilesaustralia.com.au", text: "info@schoolsmilesaustralia.com.au" },
      { type: "link", label: "Phone: ", href: "tel:0494585885", text: "0494 585 885" },
      { type: "p", text: "Website: www.schoolsmilesaustralia.com.au" },
    ],
  },
  {
    h: "Related Policies",
    blocks: [
      { type: "p", text: "These Terms and Conditions should be read together with our:" },
      { type: "ul", items: [
        "Privacy Policy",
        "Cookies Policy",
        "Website Disclaimer",
      ]},
      { type: "p", text: "These documents are available on the School Smile Australia website." },
    ],
  },
];

const Terms = () => {
  if (typeof document !== "undefined") document.title = "Terms & Conditions — School Smiles Australia";
  return (
    <LegalPage
      title="Website Terms and Conditions"
      kicker="Legal"
      isDraft={false}
      effectiveDate="16 August 2026"
      lead="These Terms and Conditions govern your access to and use of the School Smile Australia website. Please read them carefully before using the site."
      sections={sections}
      lastUpdated={LEGAL_LAST_UPDATED}
    />
  );
};

export default Terms;
